import React, { useEffect, useState, useRef } from "react";
import { Grid, Box, Typography, Button, Popover } from "@mui/material";
import { ORG_ID, SW3RD_PARTY_INSPECTOR } from "../../../../constant/constant";
import {
  ADMIN_ADD_STORM_WATERPROJECT,
  ADMIN_RESOURCE,
  INSPECTION_AUTHORITY,
  SETUP_INSPECTION,
  SETUP_INSPECTION_LIST,
  SW_ADMIN_SAMPLINGLOG,
  SW_CONTACT_PROJECT,
  SW_INSPECTION_LIST,
  SW_OPEN_ITEMS,
  SW_PERMIT_LIST,
  SW_RAIN_FALL_DATA,
} from "../../../../constant/routeContant";
import ToolBar from "../../../../library/storm-water/toolBar";
import { checkPrivileges, hasAllPrivileges } from "../../../../utils/rolesHelper";
import { useNavigate } from "react-router-dom";
import { getLabel } from "../../../../utils/helper";
import QrCodeDownload from "./QrCodeDownload";

const ViewProject = (props) => {
  const [projectData, setProjectData] = useState();
  const [locationData, setLocationData] = useState();
  const navigate = useNavigate();
  const [anchorElqr, setAnchorElqr] = useState(null);
  const openQr = Boolean(anchorElqr);
  const idQr = openQr ? "simple-popover" : undefined;
  const qrCodeRef = useRef(null);

  const toolBarDataEditMode = {
    title: "Project Tools",
    list: [
      {
        id: 13,
        title: "View Project",
        link: "",
        activeClass: "active",
        isshow: checkPrivileges([12, 113, 111, 112]),
      },
      {
        id: 11,
        title: "Edit Project",
        link: "",
        activeClass: "",
        isshow: checkPrivileges([12, 111, 112]),
      },
      {
        id: 1,
        title: "Project Contacts",
        link: "",
        isshow: checkPrivileges([12, 132, 133, 134]),
      },
      {
        id: 2,
        title: "Inspection Service List",
        link: "",
        isshow: checkPrivileges([12, 99, 100, 101]),
      },
      {
        id: 9,
        title: "Setup Inspections",
        link: "",
        isshow: checkPrivileges([12, 99, 100]),
      },
      {
        id: 3,
        title: "Permits",
        link: "",
        isshow: checkPrivileges([12, 126, 127, 128]),
      },
      {
        id: 4,
        title: "Sampling Log",
        link: "",
        isshow: checkPrivileges([12, 129, 130, 131]),
      },
      {
        id: 5,
        title: "Open Items",
        link: "",
        isshow: checkPrivileges([12, 105, 106, 107]),
      },
      {
        id: 6,
        title: "Rainfall Data",
        link: "",
        isshow: !hasAllPrivileges(SW3RD_PARTY_INSPECTOR),
      },
      {
        id: 7,
        title: "Inspection Records",
        link: "",
        isshow: checkPrivileges([12, 102, 103, 104]),
      },

      {
        id: 8,
        title: "Inspection Authority",
        link: "",
        isshow: checkPrivileges([12, 96, 97, 98]),
      },
      {
        id: 12,
        title: "Project Resources",
        link: "",
        isshow: checkPrivileges([12, 73, 74, 75]),
      },
    ],
  };

  useEffect(() => {
    setLocationData(props?.locationData);
    setProjectData(props?.projectData);
  }, [props?.projectData, props?.locationData]);

  const handleCloseQr = () => {
    setAnchorElqr(null);
  };

  const handleDownloadAsPDF = () => {
    qrCodeRef.current?.(props?.projectDataQr, "pdf");
    handleCloseQr();
  };

  const handleDownloadAsPNG = () => {
    qrCodeRef.current?.(props?.projectDataQr, "png");
    handleCloseQr();
  };
  const onClickQrCodeDownload = (event) => {
    setAnchorElqr(event.currentTarget);
  };
  return (
    <>
      <div className="overidePersonal">
        <Grid container>
          <Grid lg={8} md={12} xs={12} pr={2}>
            <div className="viewOverideContact">
              <div className="commonOveride">
                <Box className="commoninfoWrap shadow-over padding-over">
                  <Box className="commoninfoBox">
                    <Box className="commoninfoleft with-over-100">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={2}
                      >
                        <Typography className="title">
                          Project Details:
                        </Typography>

                        <Box sx={{ display: "none" }}>
                          <QrCodeDownload
                            ref={qrCodeRef}
                            projectData={props?.projectDataQr}
                            renderScanner={true}
                          />
                        </Box>
                        <Button
                          variant="contained"
                          style={{
                            height: "44px",
                            backgroundColor: "#34A853",
                            color: "white",
                            borderRadius: "100px",
                            textTransform: "none",
                            boxShadow: "none",
                            transition: "none",
                            fontFamily: "Lato",
                            fontSize: "12px",
                            fontWeight: "600",
                            padding: "0px 15px",
                          }}
                          onClick={onClickQrCodeDownload}
                        >
                          Download QR Code
                        </Button>
                        <Popover
                          id={idQr}
                          open={openQr}
                          anchorEl={anchorElqr}
                          onClose={handleCloseQr}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <Box
                            sx={{
                              p: 2,
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                              boxShadow: "none",
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{ cursor: "pointer", color: "#333333" }}
                              onClick={handleDownloadAsPDF}
                            >
                              Download PDF
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{ cursor: "pointer", color: "#333333" }}
                              onClick={handleDownloadAsPNG}
                            >
                              Download PNG
                            </Typography>
                          </Box>
                        </Popover>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView">
                          Project Type:
                          <span className="font-w400">
                            {projectData?.isStandalone
                              ? "Standalone"
                              : "Under a Site"}
                          </span>
                        </Typography>
                        <Typography className="listView">
                          Fluid Inspection :
                          <span className="font-w400">
                            {projectData?.isFluid ? "Yes" : "No"}
                          </span>
                        </Typography>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView">
                          Division:
                          <span className="font-w400">
                            {getLabel(props?.division, projectData?.divisionId)}
                          </span>
                        </Typography>
                        <Typography className="listView">
                          Project Name:
                          <span className="font-w400">{projectData?.name}</span>
                        </Typography>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView">
                          Project Number:
                          <span className="font-w400">
                            {projectData?.projectNumber}
                          </span>
                        </Typography>
                        <Typography className="listView">
                          Disturbed Acreage:
                          <span className="font-w400">
                            {projectData?.coveredArea}
                          </span>
                        </Typography>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView">
                          Permit Enforecement:
                          <span className="font-w400">
                            {projectData?.responsibleAuthority}
                          </span>
                        </Typography>
                        <Typography className="listView">
                          Location:
                          <span className="font-w400">
                            {projectData?.location}
                          </span>
                        </Typography>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView">
                          Timezone:
                          <span className="font-w400">
                            {projectData?.timezone}
                          </span>
                        </Typography>
                        <Typography className="listView">
                          State :
                          <span className="font-w400">
                            {projectData?.state}
                          </span>
                        </Typography>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView">
                          City:
                          <span className="font-w400">{projectData?.city}</span>
                        </Typography>
                        <Typography className="listView">
                          Address/Street :
                          <span className="font-w400">
                            {projectData?.address}
                          </span>
                        </Typography>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView">
                          Zip Code:
                          <span className="font-w400">{projectData?.zip}</span>
                        </Typography>
                        <Typography className="listView">
                          Rainfall Threshold (in inches):
                          <span className="font-w400">
                            {projectData?.rainfallThreshold}
                          </span>
                        </Typography>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView">
                          Start Date:
                          <span className="font-w400">
                            {projectData?.startDate}
                          </span>
                        </Typography>
                        <Typography className="listView">
                          Sampling Required:
                          <span className="font-w400">
                            {projectData?.isSamplingRequired ? "Yes" : "No"}
                          </span>
                        </Typography>
                      </Box>
                      <Box className="columns with-over-100">
                        <Typography className="listView with-over-100">
                          Add Notes:
                          <span className="font-w400">
                            {projectData?.notes}
                          </span>
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </div>
            </div>
          </Grid>

          {/* {editMode ? ( */}
          <Grid lg={4} md={12} xs={12} pl={1}>
            <div className="toolBarBox">
              <div className="otherDetail">
                <h3>Project Details</h3>
                <h2>{projectData?.name}</h2>
                <h2>{projectData?.projectNumber}</h2>
              </div>

              <div className="otherDetail">
                <h3>Client Name</h3>
                <h2>{locationData?.customerName}</h2>
              </div>

              <ToolBar
                toolBarData={toolBarDataEditMode}
                handleClick={(e) => {
                  if (e.id === 11) {
                    navigate(ADMIN_ADD_STORM_WATERPROJECT, {
                      state: {
                        editMode: true,
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectid: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  }
                  if (e.id === 1) {
                    navigate(SW_CONTACT_PROJECT, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  }
                  if (e.id === 2) {
                    navigate(SETUP_INSPECTION_LIST, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  }

                  if (e.id === 3) {
                    navigate(SW_PERMIT_LIST, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  }
                  if (e.id === 4) {
                    navigate(SW_ADMIN_SAMPLINGLOG, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  }
                  if (e.id === 5) {
                    navigate(SW_OPEN_ITEMS, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  }
                  if (e.id === 6) {
                    navigate(SW_RAIN_FALL_DATA, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  }
                  if (e.id === 7) {
                    navigate(SW_INSPECTION_LIST, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  }
                  if (e.id === 8) {
                    navigate(INSPECTION_AUTHORITY);
                  }
                  if (e.id === 9) {
                    navigate(SETUP_INSPECTION, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                        rightSideMode: true,
                      },
                    });
                  }
                  if (e.id === 12) {
                    navigate(ADMIN_RESOURCE, {
                      state: {
                        projectName: projectData?.name,
                        projectNumber: projectData?.projectNumber,
                        projectId: projectData?.projectId,
                        customerName: locationData?.customerName,
                        customerId: locationData?.customerId
                          ? locationData?.customerId
                          : parseInt(ORG_ID()),
                        stateId: projectData?.stateId,
                      },
                    });
                  } else return;
                }}
              />
            </div>
          </Grid>
          {/* ) : (
            ""
          )} */}
        </Grid>
      </div>
    </>
  );
};

export default ViewProject;
